import {BaseEvent, EventUpdate, isTask} from '@domain/shifthandover'
import {useCallback, useState} from 'react'

type Params = {
  originalItem: Partial<BaseEvent>
  item: Partial<BaseEvent>
  parentDoSubmit: (item: EventUpdate) => void
}

export const useTaskResolvedCommentDialog = ({
  originalItem,
  item,
  parentDoSubmit
}: Params) => {
  const [isMandatoryCommentDialog, setMandatoryCommentDialog] = useState(false)

  const submitWithMandatoryCommentCheck = useCallback(
    (nextItem: EventUpdate) => {
      const isTaskResolved =
        originalItem.status !== item.status && (item.status === 'cancelled' || item.status === 'done')

      if (isTask(item) && isTaskResolved) {
        setMandatoryCommentDialog(true)
        return
      }

      parentDoSubmit(nextItem)
    },
    [item, originalItem.status, parentDoSubmit]
  )

  const closeMandatoryCommentDialog = useCallback(() => {
    setMandatoryCommentDialog(false)
  }, [])

  const submitResolvedComment = useCallback(
    (taskResolvedComment: string) => {
      if (!isTask(item)) {
        return
      }

      parentDoSubmit({
        ...item,
        taskResolvedComment
      } as EventUpdate)
    },
    [item, parentDoSubmit]
  )

  return {
    isMandatoryCommentDialog,
    submitWithMandatoryCommentCheck,
    closeMandatoryCommentDialog,
    submitResolvedComment
  }
}
